import Vue from 'vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Dropdown from '@/components/dropdown/Dropdown.vue'
import Tree from '@/components/tree/Tree.vue'
import Sidebar from '@/components/sidebar/Sidebar.vue'
import Loader from '@/components/loader/Loader.vue'
import Search from '@/components/search/Search.vue'
import SearchMapLevel from '@/components/searchMapLevel/SearchMapLevel.vue'
import CamsList from '@/components/camsList/CamsList.vue'
import MapList from '@/components/mapList/MapList.vue'
import ViewTabs from '@/modules/viewTabs/ViewTabs.vue'
import Alarms from '@/modules/alarms/Alarms.vue'
import UserInfo from '@/modules/userInfo/UserInfo.vue'
import { EventBus } from '@/services//EventBus.js'


function getVisualRectPersent() {
    return {
        left: 0,
        right: 100,
        top: 0,
        bottom: 100
    }
}

export default {
    name: 'Dashboard',
    data() {
        return {
            videoStreams: [
                { name: 'Base', value: 1 },
                { name: 'Low resolution', value: 2 },
                { name: 'High resolution', value: 3 },
            ],
            modes: [
                { name: 'Live', value: 0, alias: 'live' },
                { name: 'Playback', value: 1, alias: 'playback' },
            ],
            sidebars: {
                cams: {
                    open: true,
                    show: true,
                    search: '',
                    scroll: null,
                    modes: {
                        active: 'list',
                        list: [
                            { name: 'List', value: 'list' },
                            { name: 'Preview', value: 'preview' }
                        ]
                    }
                },
                maps: {
                    open: true,
                    search: '',
                    modes: {
                        active: 'map',
                        list: [
                            { name: 'Map', value: 'map' },
                            { name: 'Video', value: 'views' }
                        ]
                    },
                    isViewCamsSetted: false
                },
            },
            loading: {
                alarms: false
            },
            modals: {
                agreement: true
            },
            visualRectPersent: getVisualRectPersent()
        }
    },
    components: {
        ViewTabs,
        Dropdown,
        Tree,
        Sidebar,
        Loader,
        VuePerfectScrollbar,
        UserInfo,
        Search,
        SearchMapLevel,
        CamsList,
        MapList
    },
    created: function () {
        this.$store.dispatch('getViews')
        this.$store.dispatch('getMaps')

        EventBus.$on('resize:end', this.onResizeEnd)
        EventBus.$on('changeMapPosition', this.onChangeMapPosition)
    },
    mounted() {
        this.setCamsMode('list')
    },
    beforeDestroy() {
        EventBus.$off('resize:end', this.onResizeEnd)
        EventBus.$off('changeMapPosition', this.onChangeMapPosition)
    },
    computed: {
        ...mapGetters({
            maps: 'getMaps',
            alarmMaps: 'getAlarmMaps',
            allCams: 'getCams',
            alarms: 'getAlarms',
            latestAlarms: 'getLatestAlarms',
            user: 'getUser',
            activeView: 'getActiveView',
            grids: 'getGrids',
            stream: 'getStream',
            activeGrid: 'getActiveGrid',
            activeMap: 'getActiveMap'
        }),
        cams() {
            let cams = this.allCams.filter(item => {
                let name = item.name.toLowerCase()
                let search = this.sidebars.cams.search.toLowerCase()

                return name.indexOf(search) > -1
            })

            return cams || []
        },
        disableGrid() {
            return this.$route.name === 'alarms'
                || (this.$route.name === 'map' && this.$store.state.mapMode === 'map')
                || (this.$route.name === 'map' && this.activeMap && !this.activeMap.cams.length)
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                if (route.name !== 'views') {
                    this.sidebars.maps.isViewCamsSetted = false
                }
                switch (route.name) {
                    case 'alarms':
                        this.sidebars.cams.show = false
                        this.sidebars.maps.open = false
                        break

                    case 'views':
                        this.sidebars.cams.show = true;

                        if (route.params.mapId && route.params.mapGroupId)
                            this.sidebars.maps.modes.active = 'views'

                        this.$nextTick(() => EventBus.$emit('views:select'))
                        break

                    case 'map':
                        this.sidebars.cams.show = true;
                        break
                }
            }
        },
        activeMap(map) {
            /**
             * Из за resetTempView или addCamsIntoView
             * может вызываться последовательность getters
             * getCams (использует state.views и view.cams) =>
             * getCamsMap => getMapById => getActiveMap. Это влечет зацикливание,
             * поэтому сделаем такую проверку
             * 
             * ВАЖНО - карта ЗАВИСИМА от камер, а не от параметров route.params.mapGroupId и 
             * route.params.mapId, то есть пока не пройдет хотя бы первый запрос камер 
             * getCamsMap => getMapById => getActiveMap - эти геттеры не вызовутся
             */
            // if (map && this.sidebars.maps.modes.active === 'views' && !this.sidebars.maps.isViewCamsSetted) {
            if (!map) return
            let camIds = []
            if (this.$route.params.camId !== undefined) {
                camIds = [this.$route.params.camId]
            } else {
                const camsFilter = map.cams.filter(cam => {
                    return cam.x >= this.visualRectPersent.left && cam.x <= this.visualRectPersent.right &&
                        cam.y >= this.visualRectPersent.top && cam.y <= this.visualRectPersent.bottom
                })
                camIds = camsFilter.map(cam => cam.id)
            }
            this.$store.commit('resetTempView')

            this.$store.commit('addCamsIntoView', {
                camIds,
                viewId: 'main',
            })
            this.sidebars.maps.isViewCamsSetted = true
        }
    },
    methods: {

        setMode(mode) {
            this.$store.commit('setMode', mode)

            this.$nextTick(() => {
                EventBus.$emit('mode:change')
            })
        },
        setCamsMode(mode) {
            this.sidebars.cams.modes.active = mode
            this.updateScroll(this.$refs.camsScroll)
        },
        setGrid(grid) {
            this.$store.dispatch('setGrid', grid.value)
            this.$nextTick(() => {
                EventBus.$emit('views:select')
            })
        },
        changeMapMode(mode) {
            if (mode === 'map') {
                this.visualRectPersent = getVisualRectPersent()
            }
            if (this.activeMap) {
                let params = { mapGroupId: this.activeMap.group.id, mapId: this.activeMap.id }

                if (mode === 'views')
                    params.viewId = 'main'
                this.$router.push({ name: mode, params: params })
            }

            this.sidebars.maps.modes.active = mode
        },
        onResizeEnd() {
            this.updateScroll(this.$refs.camsScroll)
            this.updateScroll(this.$refs.mapsScroll)
            this.updateScroll(this.$refs.mapsAlarmScroll)
        },
        onChangeMapPosition(visualRectPersent) {
            this.visualRectPersent = { ...visualRectPersent }
        },
        getAllAlarms() {
            this.sidebars.cams.show = false
            this.$router.push({ name: 'alarms' })
        },
        updateScroll(ref) {
            if (ref) {
                this.$nextTick(() => {
                    ref.update()
                })
            }
        },
        openAlarms() {
            this.loading.alarms = true
            const params = {
                start_time: moment().startOf('day').format(),
                stop_time: moment().format(),
                max_count: 6,
            }
            if (this.$route.name === 'alarms') {
                params.max_count = 30
            }
            this.$store.dispatch('getAlarms', {
                cams: this.cams,
                params
            }).then(() => {
                this.loading.alarms = false
            })
        },
        getAlarmComment(alarm) {
            return Alarms.methods.getComment(alarm)
        },
        onSelectStream(stream) {
            this.$store.commit('changeStream', stream.value)
        },
        goToAlarm(alarm) {
            this.$store.commit('setMode', 1)
            this.$router.push({
                name: 'alarms',
                params: { alarmId: alarm.id }
            })
        },
        isCamSelected(cam) {
            if (this.activeView)
                return this.activeView.cams.some(c => c.id == cam.id)

            if (this.activeMap)
                return this.activeMap.cams.some(c => c.id == cam.id)

            return false
        }
    },
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/dashboard.js